import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  notificationSegmentsLength: 0,
  notificationSegments: [],
  notificationSegment: {},
  notificationSegmentError: "",
  formError: "",
};

export default function NotificationSegmentReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_NOTIFICATION_SEGMENT:      
      return { ...state, loading: action.payload };

    case actions.LOADING_NOTIFICATION_SEGMENT_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_NOTIFICATION_SEGMENT:
      return { ...state, saveLoading: action.payload };

    case actions.GET_NOTIFICATION_SEGMENT:
      return {
        ...state,
        notificationSegments: action.payload.notificationSegments,
        notificationSegmentsLength: action.payload.notificationSegmentsLength,
      };

    case actions.GET_NOTIFICATION_SEGMENT_BY_ID:
      return { ...state, notificationSegment: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.NOTIFICATION_SEGMENT_FAIL:
      return { ...state, notificationSegmentError: action.payload };

    default:
      return state;
  }
}
